import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  withRouter,
} from 'react-router-dom';

import {
  ExtendedFlex,
  ScrollToTopOnMount,
} from '../../../coreui';

import DashboardSummary from '../../components/DashboardSummary';
import Reits from '../../components/Reits';
import PrivatePlacements from '../../components/PrivatePlacements';

class ActiveInvestmentsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const data = {
      autoinvestConfigs: this.props.autoinvestConfigs,
      ...this.props.data,
    };

    return (
      <ExtendedFlex
        flexDirection="column"
        width="100%"
        alignItems="center"
      >
        <ScrollToTopOnMount />
        <DashboardSummary
          data={data}
        />
        <Reits
          data={data}
        />
        {
          this.props.data.activeInvestmentsData.privatePlacementData !== undefined &&
          <PrivatePlacements
            data={this.props.data}
            type="active"
          />
        }
      </ExtendedFlex>
    );
  }
}

// TODO: HERE. Implement flow
ActiveInvestmentsContainer.propTypes = {
  data: PropTypes.object,
  autoinvestConfigs: PropTypes.array,
};

const mapStateToProps = (state) => {
  return {
    data: state.dashboard.data,
    autoinvestConfigs: state.autoInvest.configs,
  };
};

export default withRouter(connect(mapStateToProps)(ActiveInvestmentsContainer));
